import { memo } from 'react';
import notEmpty from '../../../core/util/notEmpty';
import SpinnerPage from '../../../core/components/pages/SpinnerPage';
import useProductDetails from '../../queries/useProductDetails';
import withErrorBoundary from '../../../core/components/errors/withErrorBoundary';
import PageNotFound from '../../../core/components/router/PageNotFound';
import ProductDetailsContent from './ProductDetailsContent';

const ProductDetails = () => {
    const { loading, product, variantId } = useProductDetails({
        includePrice: false,
        includeRelatedItemsPrice: false,
    });

    const isEmpty = !notEmpty(product);

    if (loading) {
        return <SpinnerPage />;
    }

    if (isEmpty) {
        return <PageNotFound />;
    }

    return <ProductDetailsContent product={product} variantId={variantId} />;
};

export default memo(withErrorBoundary(ProductDetails));
